import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { RegisterUserHandler } from "../../../../models/domains/pbm/user/register-user-handler";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { UserService } from "src/app/ui/services/user.service";
import { Toast } from "./../../../toast/toast";
import { LoadingService } from "src/app/ui/services/loading.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";
import { RegisterUserFormValidator } from "../validators/register-user-form.validator";
import { MaskInput } from "./../../../../models/domains/masks/mask.model";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { ConfirmDialog } from "../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { UserCompanyInfo } from "src/app/ui/models/domains/pbm/user/user-company-info";
import { User } from "src/app/ui/models/domains/pbm/user/user";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";
import { City } from "src/app/ui/models/domains/pbm/state/city";
import { StateService } from "src/app/ui/services/pbm/state.service";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";
import { UserPermissions } from "src/app/ui/models/domains/pbm/user/user-permissions";
import { UserPermission } from "src/app/ui/models/domains/pbm/user/user-permission";
import { UserRoleTypes } from "src/app/ui/models/domains/pbm/user/user-role-types";
import { SelectionModel } from "@angular/cdk/collections";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
@Component({
  selector: "register-user",
  templateUrl: "./register-user.component.html",
  styleUrls: ["./register-user.component.scss"],
})
export class RegisterUserComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  fieldDirective = {
    email: {
      visible: () => !this.isExternalManager(),
    },
    externalClientId: {
      visible: () => this.isExternalManager(),
    },
    password: {
      visible: () => !this.isExternalManager(),
    },
    isHealthProfessional: {
      visible: () => !this.isExternalManager(),
    },
    telephone: {
      visible: () => !this.isExternalManager(),
    },
  };

  private user: User = new User();
  userForm: UntypedFormGroup;
  userRoleList: UserRole[];
  telephoneMaskInput = MaskInput.getTelephoneMask();
  mobileMaskInput = MaskInput.getMobileMask();
  fiscalNumberMaskInput = MaskInput.getFicalNumberMask();
  public displayedColumns: Array<string>;
  private pageableResult: PageableResult = new PageableResult();
  public selectedCompanies = new SelectionModel<Company>(true, []);
  public allCompanies = [];
  public dataSource = new MatTableDataSource<Company>();
  private confirmDialogRef: MatDialogRef<ConfirmDialog>;
  public passwordFocused: boolean = false;
  public initialTableState: Array<{
    fiscalNumber: string;
    initialState: boolean;
  }> = []; //Apenas para visualização em tela
  public filterParams: ICompanyFilterParams;
  private stateList: Array<StateAcronym> = [];
  private cityList: Array<City> = [];
  private userPermissionList: Array<UserPermission>;
  private userKey: string;
  public isEditing: boolean;
  private registerUserHandler: RegisterUserHandler;

  constructor(
    private featureViewService: FeatureViewService,
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private userService: UserService,
    private toast: Toast,
    private router: Router,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private stateService: StateService,
    private activatedRoute: ActivatedRoute,
    private cdref: ChangeDetectorRef
  ) {
    this.userKey = this.activatedRoute.snapshot.params.userKey;

    /**
     * Parâmetros iniciais para a busca de Companies
     */
    this.filterParams = {
      filterText: "",
      companyType: 2, // 0 = Apenas Matriz; 1 = Apenas Filiais; 2 = Todas
      address: {
        city: "",
        region: "",
      },
    };
  }

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.UserRegisterFeatureView, PageViews.UserPageView);
    this.userForm = this.formBuilder.group({
      userKey: [""],
      name: ["", Validators.required],
      email: ["", Validators.required],
      password: ["", Validators.required],
      telephoneType: [null],
      telephone: ["", Validators.required],
      fiscalNumber: [{ value: "", disabled: false }],
      isHealthProfessional: [false],
      classCouncil: [""],
      registrationNumber: [""],
      userRole: ["", Validators.required],
      externalClientId: ["", Validators.required],
      userPermissionList: [[]],
      allowedCompanies: [[]],
      active: [false],
      changePassword: [false],
      newPassword: [""],
      confirmNewPassword: [""],
      filterText: [this.filterParams.filterText],
      companyType: [this.filterParams.companyType],
      city: [this.filterParams.address.city],
      region: [this.filterParams.address.region],
    });

    this.displayedColumns = ["check", "status", "fiscalNumber", "companyType", "corporateName", "region", "city"];
    this.dataSource.paginator = this.paginator;
    await this.checkUserParam();
  }

  ngAfterContentChecked() {
      this.cdref.detectChanges();
  }

  private async checkUserParam() {
    const ref = this.loadingService.beginLoading();
    try {
      this.userRoleList = await this.userService.requestUserRoles();
      this.stateList = await this.stateService.getStates();
      if (this.userKey) {
        this.isEditing = true;
        this.user = await this.userService.searchUserByUserKey(this.userKey);
        this.userForm.get("userRole").valueChanges.subscribe((value: UserRole) => (this.userPermissionList = value.getUserPermissionList()));
        this.registerUserHandler = new RegisterUserHandler();
        this.registerUserHandler.handlerUserToForm(this.userKey, this.user, this.userRoleList, this.userForm);
        await this.doSearchAllCompanies();
        this.setPreviouslySelectedCompanies();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  async doSaveUser() {
    const ref = this.loadingService.beginLoading();
    const userFormValidator = new RegisterUserFormValidator();
    if (!this.canAllowPermissionPerCompany()) {
      this.selectedCompanies.select(...this.dataSource.data);
    }
    this.userForm.patchValue({
      allowedCompanies: this.selectedCompanies.selected,
    });

    if (userFormValidator.validate(this.userForm, this.isEditing).hasErrorMessages()) {
      this.loadingService.finishLoading(ref);
      this.toast.showWarningToast(userFormValidator.getValidationResult().getErrorMessage());
    } else {
      try {
        const registerUserHandler = new RegisterUserHandler();
        this.user = registerUserHandler.handlerFormToUser(this.userForm);

        if (this.isEditing) {
          const newPassword = this.userForm.get("newPassword").value;
          const confirmNewPassword = this.userForm.get("confirmNewPassword").value;
          await this.userService.updateUser(this.user, newPassword, confirmNewPassword);
          this.toast.showSuccessToast("Usuário regravado com sucesso!");
        } else {
          const password = this.userForm.get("password").value;
          await this.userService.addUser(this.user, password);
          this.toast.showSuccessToast("Usuário salvo com sucesso!");
        }
        this.router.navigate([RoutePath.SearchUser]);
      } catch (error) {
        this.toast.showWarningToast(error.errorMessage);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  canShowUserPermissions(): boolean {
    const selectedRole = this.userForm.get("userRole").value;

    return (
      selectedRole &&
      (selectedRole.userRoleType === UserRoleTypes.Manager ||
        selectedRole.userRoleType === UserRoleTypes.CompanyManager ||
        selectedRole.userRoleType === UserRoleTypes.Audit ||
        selectedRole.userRoleType === UserRoleTypes.Tester)
    );
  }
  getTelephoneMask(typeSelectedByUser) {
    let retMask: any = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]; // valor default que aceita todos os números e em qualquer posição.
    if (this.user.getUserKey()) {
      const phoneType = this.userForm.get("telephoneType").value;
      retMask = phoneType == 0 || phoneType == 1 ? (phoneType == 0 ? this.telephoneMaskInput : this.mobileMaskInput) : retMask;
    } else if (typeSelectedByUser) {
      const type = typeSelectedByUser.value;
      retMask = type == 0 || type == 1 ? (type == 0 ? this.telephoneMaskInput : this.mobileMaskInput) : retMask;
    }
    return retMask;
  }

  canAllowPermissionPerCompany(): boolean {
    return this.userForm.get("userRole").value && this.userForm.get("userRole").value.isCompanyManagerRole();
  }

  permissionList(): Array<UserPermission> {
    if (this.userForm.get("userRole").value) {
      let list = this.userForm.get("userRole").value.getUserPermissionList() as Array<UserPermission>;
      if (this.canAllowPermissionPerCompany()) {
        // gestor RH não pode cadastrar empresas. Ele só tem acesso as que foram associadas a ele por um ADM Interplayers
        return list.filter((perm) => {
          return perm.getCode() !== "ADD_COMPANY";
        });
      } else {
        return list;
      }
    }
    return [];
  }

  public onUserRoleChange(): void {
    this.selectedCompanies.clear();
    this.userForm.get("userPermissionList").value;
    this.userForm.patchValue({ ["userPermissionList"]: [] });
    this.userForm.patchValue({ ["externalClientId"]: "" });
  }
  isExternalManager(): boolean {
    const role = this.userForm.get("userRole").value;
    if (role) return role.userRoleType == UserRoleTypes.ExternalManager;
    return false;
  }
  isAllSelected() {
    const numSelected = this.selectedCompanies.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selectedCompanies.clear();
      return;
    }
    this.selectedCompanies.clear();
    this.allCompanies.forEach((company) => {
      this.selectedCompanies.selected.push(company);
    });
  }

  selectCompany(element: Company) {
    const idx = this.getIsSelected(element);
    if (idx == -1) {
      this.selectedCompanies.selected.push(element);
    } else {
      this.selectedCompanies.selected.splice(idx, 1);
    }
    this.checkCompanyType(element);
    this.dataSource.sort = this.sort;
  }

  /**
   * O método nativo this.selectedCompanies.isSelected(element) não funciona neste contexto pois
   * ele faz referência a objetos. Quando os dados de "allCompanies" eram atualizados, perdiam-se
   * as referências dos objetos selecionados mesmo ainda estando na lista "selectedCompanies".
   * Faz a busca "manualmente" verificando pelo identificador fiscalNumber (CNPJ).
   * @param element Company this.selectedCompanies.
   * @returns índice do elemento. Se não encontrar, retorna -1
   */
  getIsSelected(element: Company): number {
    let ret = -1;
    for (let i = 0; i < this.selectedCompanies.selected.length; i++) {
      const selected = this.selectedCompanies.selected[i];
      if (element?.getFiscalNumber() === selected.getFiscalNumber()) {
        ret = i;
        break;
      }
    }
    return ret;
  }

  checkCompanyType(company: Company) {
    if (company.getCompanyType() == 0) {
      const rootFiscalNumber = company.getFiscalNumber().slice(0, 8);
      const branches = this.dataSource.data.filter((c) => {
        return c.getCompanyType() !== 0 && c.getFiscalNumber().slice(0, 8) == rootFiscalNumber;
      });

      if (branches.length > 0) {
        this.confirmDialogRef = this.dialog.open(ConfirmDialog, {
          disableClose: true,
          hasBackdrop: true,
          height: "200px",
          width: "600px",
          data: {
            title: "Esta empresa é uma Matriz.",
            text: "Deseja replicar esta ação para todas as filiais?",
          },
        });

        this.confirmDialogRef.componentInstance.confirmDialogEvent.subscribe(async () => {
          branches.forEach((branch) => {
            if (this.getIsSelected(company) !== -1) {
              const idx = this.getIsSelected(branch);
              if (idx == -1) {
                this.selectedCompanies.selected.push(branch);
              }
            } else {
              const idx = this.getIsSelected(branch);
              if (idx != -1) {
                this.selectedCompanies.selected.splice(idx, 1);
              }
            }
          });
        });
      }
    }
  }

  public  pageChange() {
    const data = this.allCompanies;
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    const endIndex = startIndex + this.paginator.pageSize;
    const paginatedData = data.slice(startIndex, endIndex);
    this.dataSource.data = paginatedData;
    this.paginator.length = this.pageableResult.getTotalItems();
  }

  /**
   * Busca todas as empresas cadastradas para exibir na tela e comparar com a lista de empresas
   * permitidas para o usuário
   */
  public async doSearchAllCompanies() {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(1);
    pagingRequest.setEnd(9999);
    this.filterParams = {
      filterText: this.userForm.get("filterText").value.replace(/[./-]/g, "").slice(0, 8),
      companyType: this.userForm.get("companyType").value,
      address: {
        city: this.userForm.get("city").value,
        region: this.userForm.get("region").value,
      },
    };

    await this.companyService
      .searchCompany(this.filterParams, pagingRequest)
      .then((pageableResult) => {
        this.pageableResult.setStart(1);
        this.pageableResult.setEnd(9999);
        this.pageableResult.setTotalItems(pageableResult.getTotalItems());
        this.pageableResult.setItems(pageableResult.getItems());
        this.allCompanies = <Array<Company>>this.pageableResult.getItems();

        if (this.allCompanies.length == 0) {
          this.toast.showWarningToast("Nenhum resultado encontrado para os filtros selecionados", "Atenção!");
          return;
        }

        if (!this.isEditing) {
          // quando está editando, faz só 1 vez na inicialização da tela
          this.setPreviouslySelectedCompanies();
        }
        this.pageChange();
        this.dataSource._updatePaginator(this.pageableResult.getTotalItems());
        this.dataSource._updateChangeSubscription();
      })
      .catch(() => {
        this.pageableResult.setItems(null);
      })
      .finally(() => {
        this.loadingService.finishLoading(ref);
      });
  }

  getSelectedDescription(): string {
    return this.selectedCompanies.selected.length == 0
      ? "Nenhum selecionado"
      : this.selectedCompanies.selected.length == 1
        ? "1 selecionado"
        : this.selectedCompanies.selected.length + " selecionados";
  }

  /**
   * Insere na lista de selecionadas (selectedCompanies) as empresas vinculadas anteriormente para o
   * usuário em questão, caso tenha.
   */
  setPreviouslySelectedCompanies(): void {
    this.allCompanies.forEach((comp) => {
      if (this.userKey) {
        const allowedCompanies = this.user.getAllowedCompanies().map(compUser => compUser.getFiscalNumber());
        const isAllowed = allowedCompanies.includes(comp.getFiscalNumber());

        if (isAllowed && this.getIsSelected(comp) === -1) {
          this.selectedCompanies.selected.push(comp);
        }

        this.setInitialTableState({
          fiscalNumber: comp.getFiscalNumber(),
          initialState: isAllowed,
        });
      } else {
        this.setInitialTableState({
          fiscalNumber: comp.getFiscalNumber(),
          initialState: false,
        });
      }
    });
  }

  getTableState(company: Company): string {
    if (!this.initialTableState.length) {
      return "";
    }
    const initialState = this.initialTableState.find(ts => ts.fiscalNumber === company.getFiscalNumber())?.initialState;
    const currentState = this.getIsSelected(company) !== -1;

    if (initialState !== undefined) {
      if (initialState !== currentState) {
      return "Alterado";
      } else if (initialState) {
      return "Salvo";
      }
    }
    return "";
  }

  setInitialTableState(state: { fiscalNumber: string; initialState: boolean }) {
    this.initialTableState.push(state);
  }

  setPasswordFocused(isFocused: boolean) {
    this.passwordFocused = isFocused;
  }

  /**
   * Faz o parse dos itens da tabela de CNPJs (Company)
   * para itens do tipo (UserCompanyInfo) que serão armazenados no usuário
   * @returns Array<UserCompanyInfo>
   */
  getSelectedCompaniesInfo(): Array<UserCompanyInfo> {
    let data: Array<UserCompanyInfo> = new Array<UserCompanyInfo>();
    this.selectedCompanies.selected.forEach((selectedCompany) => {
      const userCompanyInfo: UserCompanyInfo = new UserCompanyInfo();
      userCompanyInfo.setTelephone(this.userForm.get("telephone").value);
      userCompanyInfo.setFiscalNumber(selectedCompany.getFiscalNumber());
      userCompanyInfo.setCorporateName(selectedCompany.getCorporateName());
      userCompanyInfo.setHealthProfessional(this.userForm.get("isHealthProfessional").value);
      userCompanyInfo.setClassCouncil(this.userForm.get("classCouncil").value);
      userCompanyInfo.setRegistrationNumber(this.userForm.get("registrationNumber").value);
      data.push(userCompanyInfo);
    });
    return data;
  }

  isPasswordValid(password: string): boolean {
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*(){}\-_])[A-Za-z0-9#?!@$%^&*(){}\-_]{8,}$/;
    return passwordRegex.test(password);
  }

  comparePasswords(newPassword, confirmNewPassword): boolean {
    return newPassword && confirmNewPassword ? newPassword.value == confirmNewPassword.value : false;
  }

  async onStateInputChange() {
    const value = this.userForm.get("region").value;
    let state: StateAcronym = new StateAcronym(value);
    if (state.getValue() !== "") {
      const ref = this.loadingService.beginLoading();
      try {
        this.cityList = await this.stateService.getCityByStateAcronym(state);
        this.userForm.get("city").enable();
        this.userForm.get("city").setValue("");
      } catch (error) {
        this.cityList = [];
        this.userForm.get("city").disable();
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.cityList = [];
      this.userForm.get("city").setValue("");
      this.userForm.get("city").disable();
    }
  }

  getStateList(): Array<StateAcronym> {
    return this.stateList;
  }

  getCityList(): Array<City> {
    return this.cityList;
  }

  sortTable() {
    if (this.sort.direction === "asc") {
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        if (this.getIsSelected(a) !== -1 && !(this.getIsSelected(b) !== -1)) {
          return -1;
        } else if (this.getIsSelected(b) !== -1 && !(this.getIsSelected(a) !== -1)) {
          return 1;
        }
      });
    } else if (this.sort.direction === "desc") {
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        if (this.getIsSelected(a) !== -1 && !(this.getIsSelected(b) !== -1)) {
          return 1;
        } else if (this.getIsSelected(b) !== -1 && !(this.getIsSelected(a) !== -1)) {
          return -1;
        }
      });
    } else {
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        if (a.getCorporateName() === b.getCorporateName()) {
          return Number.parseInt(a.getFiscalNumber()) - Number.parseInt(b.getFiscalNumber());
        }
        return a.getCorporateName() > b.getCorporateName() ? 1 : -1;
      });
    }
  }

  hasAccessToEditUser(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.EditUser);
  }
}
